export default __webpack_public_path__ + "static/media/SP color.cd2bb862.png";